import { Card } from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { GeneralHeader } from '@/components/HeaderPage/HeaderPage';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { type ClipMention } from '@/features/clips/types';
import { convertISOToSeconds } from '@/utils/hh-mm-ss-into-number';

import { ClipToolkitMentionsTable } from './components/ClipToolkitMentionsTable';

export default function ClipToolkitMentions() {
  const { t } = useTranslation();
  const { activeClip, videoControlRef } = useBroadcastScheduleProgram();

  const handlePreviewBox = (box: ClipMention) => {
    if (!activeClip) return;

    const seconds = convertISOToSeconds(box.start_datetime, new Date(activeClip.start_datetime));

    videoControlRef.current?.seekToSecond(seconds || 0);
  };

  return (
    <Card
      classes={{
        rootSection: clsx('w-full flex-auto order-3 lg:order-2'),
        container: 'py-size-4',
      }}
    >
      <div className="flex w-full flex-col gap-2">
        <GeneralHeader name={t('Keywords')} />
        <ClipToolkitMentionsTable
          items={activeClip?.clip_mentions || []}
          onPreview={handlePreviewBox}
        />
      </div>
    </Card>
  );
}
